import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';

export default class PayFreeCash extends BaseDangerDetail {
    constructor(props) {
        super(props);
        this.title = '支付的其他与经营活动有关的现金';
    }

    getColumns = () => {
        return [{
            title: '项目',
            dataIndex: 'item'
        }, {
            title: '本期发生额',
            dataIndex: 'thisyear'
        }, {
            title: '上期发生额',
            dataIndex: 'lastyear'
        }];
    };
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialFraudAnalysis/subComponents/details/PayFreeCash.jsx